import { Link } from "react-router-dom";

export default function SubmitCta() {
  return (
    <section className="relative px-4 md:px-8 py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20editorial%20texture%20of%20layered%20paper%20documents%20and%20light%20rays%20falling%20across%20a%20desk%2C%20deep%20vermillion%20and%20amber%20color%20palette%20with%20cream%20highlights%2C%20soft%20cinematic%20lighting%2C%20minimal%20artistic%20background%20without%20text&width=1600&height=800&seq=bl-cta-submit-01&orientation=landscape"
        alt="投稿背景：暖色调的纸张与光影"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-primary-950/80" />
      <div className="relative max-w-3xl">
        <p className="font-label text-xs text-accent-300 tracking-[0.25em] uppercase">Submit</p>
        <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug tracking-tight">
          有想爆的料？现在就可以投进作品集
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed max-w-xl">
          把真实经历的细节写清楚，通过审核后就会出现在参赛作品集中，并进入对应的分类与排行榜，被更多人读到。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link
            to="/about#submit"
            className="inline-flex items-center justify-center gap-1.5 bg-accent-500 hover:bg-accent-400 text-primary-950 text-sm font-medium px-6 py-3.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-quill-pen-line" />
            </span>
            提交参赛作品
          </Link>
          <Link
            to="/works"
            className="inline-flex items-center justify-center gap-1.5 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/40 text-sm font-medium px-6 py-3.5 rounded-md whitespace-nowrap transition-colors cursor-pointer backdrop-blur"
          >
            先去作品集逛逛
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}